"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextTooltip_1 = require("./TextTooltip");
exports.default = TextTooltip_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/TextTooltip/index.js
// module id = 287
// module chunks = 8